<ng-container *ngIf="exercise">
  <form [formGroup]="form" (ngSubmit)="saveExercise()">
    <div fxLayout="column" class="exercise-editor">
      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start start" >
        <div style="box-sizing: border-box; flex: 1 1 auto" >
            <mat-form-field fxFlexFill >
              <mat-label>Exercise Name</mat-label>
              <input style="font-size: 20px;"
                matInput
                formControlName="formExerciseName"
                [readonly]="!canEdit"/>
              <mat-error *ngIf="form.get('formExerciseName').hasError('duplicateName') && form.get('formExerciseName').touched">
                Exercise already exists.
              </mat-error>
              <mat-error *ngIf="form.get('formExerciseName').hasError('required') && form.get('formExerciseName').touched">
                Exercise name is required.
              </mat-error>
            </mat-form-field>
          </div>
          <button *ngIf="!newExercise" mat-raised-button color="warn" type="button" (click)="removeExercise()" [disabled]="!canEdit">Remove Exercise
          </button>
        </div>
        <div class="title-row">
          <h3>Categories</h3>
          <button mat-raised-button color="primary"  type="button" (click)="addCategory()" [disabled]="!canEdit">Add Category
          </button>
        </div>
        <div class="categories" >
          <mat-chip-list formControlName="formCategories" style="flex-wrap: wrap; margin-bottom: 16px;">
            <mat-chip *ngFor="let category of selectedCategories" [removable]="true">
              {{category.name}}
              <mat-icon *ngIf="canEdit" matChipRemove color="warn" (click)="removeCategory(category)">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="title-row">
          <h3>Parameters</h3>
          <button mat-raised-button color="primary"  type="button" (click)="addParameter()" [disabled]="!canEdit">Add Parameter
          </button>
        </div>
        <div fxLayout="column" fxLayoutGap="16px" *ngFor="let fg of parameters.controls; let i=index">
          <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field fxFlex="40">
                <input
                matInput
              placeholder="Name"
              [formControl]="fg['controls']['name']"
              [readonly]="!canEdit"
              [matAutocomplete]="paramNamesAuto"
              (input)="filterParamAutocomplete($event.target.value, i)"
              />
          </mat-form-field>
          <mat-autocomplete #paramNamesAuto="matAutocomplete" panelWidth="500">
            <mat-option [value]="" class="default-option">---- No Selection ----</mat-option>
              <mat-option *ngFor="let name of defaultNames" [value]="name" (click)="filterParamAutocomplete(name, i)">
                {{ name }}
              </mat-option>
          </mat-autocomplete>
          <mat-form-field fxFlex="40">
            <input
            matInput
            placeholder="Unit"
            [formControl]="fg['controls'].unit"
            [readonly]="!canEdit"
            [matAutocomplete]="paramUnitsAuto"
            />
          </mat-form-field>
          <mat-autocomplete #paramUnitsAuto="matAutocomplete" panelWidth="500">
            <mat-option [value]="" class="default-option">---- No Selection ----</mat-option>
              <mat-option *ngFor="let unit of autocompleteUnits[i]" [value]="unit">
                {{ unit }}
              </mat-option>
          </mat-autocomplete>
          <mat-icon *ngIf="canEdit" (click)="removeParameter(fg)" class="clickable" style="align-self:center;">delete</mat-icon>
        </div>
      </div>
      <div fxFlex fxLayout="column" class="title-row">
        <h3>Resources</h3>
        <div fxLayout="row">
          <p>Video metadata for supported videos hosted on <a href="https://www.dvidshub.net/" rel="noopener noreferrer" target="_blank">DVIDSHUB.net</a>.</p>
        </div>
        <div fxLayout="row">
          <mat-form-field fxFlexFill>
            <input
              matInput
              matFormField
              placeholder="Video URL"
              formControlName="formResourceUrl"
              (keyup)="debouncedSetEmbedUrl()"
              [readonly]="!canEdit"
              />
            <mat-error *ngIf="form.get('formResourceUrl').hasError('invalidUrl') && form.get('formResourceUrl').touched">
              Invalid URL.
            </mat-error>
          </mat-form-field>
        </div>
        <ng-container *ngIf="loadingVideo">
          <mat-spinner fxFlexAlign="center"></mat-spinner>
        </ng-container>
        <ng-container *ngIf="videoLoaded && !loadingVideo">
          <div fxLayout="row" fxLayoutGap="16px">
            <mat-form-field fxFlex="60">
              <input
                matInput
                matFormField
                placeholder="Video Title"
                formControlName="formResourceTitle"
                [readonly]="true"/>
            </mat-form-field>
            <mat-form-field fxFlex>
              <input
              matInput
              matFormField
              placeholder="Video Asset ID"
              formControlName="formResourceAssetId"
              [readonly]="true"/>
            </mat-form-field>
          </div>
          <mat-form-field fxFlex="60">
            <textarea
              matInput
              matFormField
              placeholder="Video Description"
              formControlName="formResourceDescription"
              [readonly]="true">
            </textarea>
          </mat-form-field>
          <iframe *ngIf="this.videoLoaded && this.embedUrl; else elseBlock" [src]="this.embedUrl" width="640" height="380" frameborder="0" allowtransparency allowfullscreen>Video</iframe>
          <ng-template #elseBlock>No video</ng-template>
        </ng-container>
      </div>
      <div fxFlex fxFlexAlign="end" class="save-row">
        <button mat-raised-button color="primary" type="submit" [disabled]="!form.valid || !canEdit">Save Exercise</button>
      </div>
    </div>
  </form>
</ng-container>

